import React from 'react';

const Header = ({
  selectedCategory,
  onCategoryChange,
  searchTerm,
  onSearchChange,
  cartCount,
  onCartToggle,
}) => {
  const navItems = ['All', 'Women', 'Men', 'Beauty'];

  return (
    <header className="headerSection">
      <div className="brandBlock">
        <img src="/Assets/logo.png" alt="Unique Mart logo" className="brandLogo" />
        <div>
          <h1>Unique Mart</h1>
          <p>Modern shopping UI built with React</p>
        </div>
      </div>

      <nav className="center">
        <ul>
          {navItems.map((item) => (
            <li key={item}>
              <button
                type="button"
                className={selectedCategory === item ? 'navButton active' : 'navButton'}
                onClick={() => onCategoryChange(item)}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="headerActions">
        <div className="searchBox">
          <input
            type="search"
            name="search"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search products..."
            aria-label="Search products"
          />
        </div>

        <button type="button" className="cartButton" onClick={onCartToggle}>
          Cart <span className="cartCount">{cartCount}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
